import {management} from '../../../..'

import { DeleteRecordByIdSectorUseCase} from "./deleteRecordManagementByIdSector";

import {ManagementRepository} from '../../../infra/knex/repositories/management'

export const deleteManagementByIdSector=()=>{
  const repository=new ManagementRepository(management)

  const deleteRecord= new  DeleteRecordByIdSectorUseCase(repository)

  return deleteRecord
}
